import axios from "axios"
import { apiRoutes } from "../utils/routes"
import { AppUtil } from "../utils/app.utils"
import { WorkflowRequestPayload } from "../models/Workflow"

export const getWorkflowReportDownloadURLs = async (workflowId: string) => {
  const response = await axios.post(apiRoutes.workflow.downloadURLs,
    { workFlowId: workflowId },
    AppUtil.getCommonAPIConfig()
  )
  return response
}

export const getWorkflowReportUploadURLs = async (workflowId: string) => {
  const response = await axios.post(apiRoutes.workflow.uploadURLs,
    { workFlowId: workflowId },
    AppUtil.getCommonAPIConfig()
  )
  return response
}

export const updateWorkflowReportStatus = async (workFlowId: string, reportKey: string, presignedURL: string, isSigned: boolean) => {
  const response = await axios.post(
    apiRoutes.workflow.statusUpdate,
    { workFlowId: workFlowId, reportKey: reportKey, path: presignedURL, isSigned: isSigned },
    AppUtil.getCommonAPIConfig()
  )
  return response
}

export const getSamplesListForWorkflow = async (patientId: any, primaryTestTag: string) => {
  const response = await axios.post(
    apiRoutes.workflow.workflowSamples,
    { patientId, primaryTestTag },
    AppUtil.getCommonAPIConfig()
  )

  return response
}

export const addWorkflow = async (requestBody: WorkflowRequestPayload) => {
  const response = await axios.post(
    apiRoutes.workflow.createWorkflow,
    { ...requestBody },
    AppUtil.getCommonAPIConfig()
  )

  return response
}

export const updateWorkflow = async (requestBody: WorkflowRequestPayload) => {
  const response = await axios.put(
    apiRoutes.workflow.updateWorkflow,
    { ...requestBody },
    AppUtil.getCommonAPIConfig()
  )

  return response
}

export const getWorkFlowList = async (patientId: string | number) => {
  const response = await axios.post(
    apiRoutes.workflow.getWorkflowList,
    { patientId },
    AppUtil.getCommonAPIConfig()
  )

  return response
}

export const getWorkFlowById = async (id: string | number) => {
  const response = await axios.post(
    apiRoutes.workflow.getWorkflowById,
    { id },
    AppUtil.getCommonAPIConfig()
  )

  return response
}

export const createWorkFlowQR = async (id: string | number) => {
  const response = await axios.post(
    apiRoutes.workflow.createWorkflowQRCode,
    { id: Number(id) },
    AppUtil.getCommonAPIConfig()
  )

  return response
}

export const shipWorkflow = async (id: string | number) => {
  const response = await axios.post(
    apiRoutes.workflow.shipWorkflow,
    { id },
    AppUtil.getCommonAPIConfig()
  )

  return response
}
